import { j as o } from "../../../../../../jsx-runtime.BREq8dyb.js";
import { Alert as a } from "@mui/joy";
import { memo as r } from "react";
import { S as t } from "../../../../../../index.B-E4PB3F.js";
const s = r(({
  syncDirection: e
}) => /* @__PURE__ */ o.jsx(a, { children: e === t.IMPORT ? "This will import any object from an Amazon S3 Bucket and store it as a dataset in the Decentriq platform. Note: The imported file/dataset will be stored as is, without any data manipulation." : e === t.EXPORT ? "The selected dataset will be directly exported to an Amazon S3 Bucket and stored as an object. Note: to verify the successful export, please directly access your Bucket." : null }));
s.displayName = "S3Info";
export {
  s as default
};
//# sourceMappingURL=S3Info.js.map
